export interface ErrorMessage
{
    message: string;
    stackTrace: string
}


export class APINotFoundException 
{

}

export class APIUnauthorizedException
{

}

export class APIServerError
{

}

export class APIForbiddenError
{

}